module.exports = __webpack_public_path__ + "static/media/NorthWestTelegraph-devicecomp-min.b976c91d.webp";